import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  cursor: pointer;
  background-color: ${ ({ theme }) => theme.colors.white };
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  position: relative;
  transition: ease-in box-shadow 0.1s;
  padding: 16px;
  
  &:hover {
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.25);
  }

  .details {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 24px;
    width: 95%;
    min-width: 0;

    &.icon {
      width: 30px
    }

    .row {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      gap: 8px;
      min-width: 0;

      img {
        width: 24px;
        height: 24px;
      }

      span {
        font-family: ${ ({ theme }) => theme.fontFamily };
      }

      .service-name {
        font-weight: 700;
      }

      .warning-icon {
        flex-shrink: 0;

        &.clickable {
          cursor: pointer;
        }
      }

      .stop-name {
        display: flex;
        flex-direction: row;
        gap: 8px;
        min-width: 0;
        flex: 1;

        span {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: 600;
          font-size: 16px;
          min-width: 0;
        }
      }

      .stops-dots {
        width: 10%;
      }

      &:first-of-type {
        > span {
          font-size: 18px;
          align-self: center;
        }
      }

      &:last-of-type {
        > span {
          font-size: 14px; 
          color: ${ ({ theme }) => theme.colors.black };
          text-align: left;
        }
      }
    } 
  }

  .dotted {
    position: relative;
    bottom: 5px;
    font-size: 24px;
    font-weight: bold;
    color: ${ ({ theme }) => theme.colors.black };
  }

  @media screen and (max-width: 768px) {
    .details {
      .row {
        .stops-dots {
          width: 20%;
        }
      }
    }
  }
`
